module.exports = __webpack_public_path__ + "static/img/齿直角方式斜齿条的计算.6b978378.jpg";